up.compiler('.up-update-parent-layer', (element) => {
  const parent = up.layer.current.parent;
  element.addEventListener('click', (event) => {
    setTimeout(() => {
      up.reload('.page--content', {'layer': parent});
    }, 1000);
  })
});
